<app-navbar></app-navbar>
<div class="background">
  <div class="journey-container">
    @if (!areSectionsLoading) {
      <div class="heading-container">
        <h1>
          Hi, {{ userName }}! <br />
          Welcome back to your life-saving journey
        </h1>
      </div>
  
      <div class="explanation-text">
        <p>
          Follow each step of the living donor process with guidance, support, and
          resources tailored to you.
        </p>
        <a (click)="openContactModal()" class="btn">Contact Us</a>
      </div>
  
      <div class="journey-tabs">
        <button
          [class.active]="activeTab === 'Journey'"
          (click)="switchTab('Journey')"
        >
          Journey
        </button>
        <button
          [class.active]="activeTab === 'Knowledge'"
          (click)="switchTab('Knowledge')"
        >
          Knowledge Center
          <i class="bi bi-box-arrow-up-right ms-2" aria-hidden="true"></i>
        </button>
      </div>
  
    }
    
    <div *ngIf="activeTab === 'Journey'" class="journey-steps">
      @if (areSectionsLoading) {
        <div class="loading-spinner">
          <div class="spinner"></div>
          <p>Loading...</p>
        </div>
      } @else {
        @for (section of journeySections; track section; let i = $index) {
          <app-journey-section
            [section]="section"
            [isFirstSection]="i == 0"
            [isLastSection]="i == journeySections.length - 1"
            [isAdmin]="isAdmin"
            [donorLocale]="donorLocale"
            [isComprehensiveQuestionnaireCompleted]="
              isComprehensiveQuestionnaireCompleted
            "
          ></app-journey-section>
        }
      }
    </div>
  </div>
</div>
